import React from 'react';
import { useIntl } from 'react-intl';
import { ColumnFlexBox } from '../../../Components/FlexBox';
import { Typography } from '@mui/material';
import CaptionValue from '../../../Components/CaptionValue/CaptionValue';

const BranchCountersTooltip = function BranchCountersTooltip({ data }) {
  const intl = useIntl();
  return (
    <ColumnFlexBox gap="8px" padding="8px" minWidth="240px">
      <Typography
        variant="body1"
        sx={{
          textAlign: "center",
          fontWeight: 'bold'
        }}>
        {data?.key}
      </Typography>
      <Typography variant="body2" sx={{
        textAlign: "center"
      }}>
        {intl.messages.COMPLETED_APPOINTMENTS}
      </Typography>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          color: data?.color,
          fontWeight: 'bold'
        }}>
        {data?.value || 0}
      </Typography>
      {data?.details?.map(({ name, count }) => (
        <CaptionValue
          key={name}
          direction="row"
          width="100%"
          caption={name}
          value={count?.toString()}
          valueColor={data?.color}
          captionStyle={{ flexGrow: 1 }}
          valueStyle={{ fontWeight: 'bold' }}
          captionColor="#fff"
        />
      ))}
    </ColumnFlexBox>
  );
};

export default BranchCountersTooltip;
